export const openLink = (href) => {
  window.open(href, 'newwindow', 'width=600, height=400');
};

export default openLink;
